enum OcurrenceActionPlanStatus {
    //'Aberto', 'Em andamento', 'Fechado'
    Open = 1,
    InProgress = 2,
    Closed = 3
}

export default OcurrenceActionPlanStatus;